export const PRIORITY_OPTIONS = [
  { name: 'Critical', id: 10 },
  { name: 'High', id: 20 },
  { name: 'Medium', id: 30 },
  { name: 'Low', id: 40 }
]

export const STATE_OPTIONS = [
  { name: 'Open', id: 0 },
  { name: 'Closed', id: 1 }
]

